import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { saratogaSpringsConfig } from "./data";

export default function SaratogaSpringsPage() {
  return <CityPageTemplate config={saratogaSpringsConfig} />;
}